<template>
  <div class="user-manual-wrap">
    <scan-barcode v-on:setBarcode="getBarcode">
      <h3>請掃描條碼以更新登入用條碼</h3>
    </scan-barcode>
  </div>
</template>

<script>
import ScanBarcode from '../flowComp/ScanBarcode';

export default {
  name: 'Barcode',
  components: {
    ScanBarcode,
  },
  methods: {
    getBarcode(val) {
      this.instance.patch(`/api/user/${this.user.id}/`, {
        barcode: val,
      })
      .then((res) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        // this.$router.push({ name: 'Main' });
      })
      .catch(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '更新失敗',
        });
      });
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Barcode.vue?8684f102